import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FieldLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: 'var(--am-text-secondary)',
  marginBottom: '4px',
}) as typeof Typography;
